import MuiDialogContent, {
  DialogContentProps,
} from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

export default function DialogContent({
  children,
  ...rest
}: DialogContentProps) {
  return (
    <MuiDialogContent {...rest}>
      <DialogContentText component="div">{children}</DialogContentText>
    </MuiDialogContent>
  );
}
